var _path, _path2;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPrivateTempIcon = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 14.25V18C16.6666 18.221 16.5788 18.4329 16.4225 18.5892C16.2662 18.7455 16.0543 18.8333 15.8333 18.8333H13.1249M16.6666 7.16663V2.99996C16.6666 2.77895 16.5788 2.56698 16.4225 2.4107C16.2662 2.25442 16.0543 2.16663 15.8333 2.16663H4.16659C3.94557 2.16663 3.73361 2.25442 3.57733 2.4107C3.42105 2.56698 3.33325 2.77895 3.33325 2.99996V18C3.33325 18.221 3.42105 18.4329 3.57733 18.5892C3.73361 18.7455 3.94557 18.8333 4.16659 18.8333H6.66659",
    stroke: "#9BA4AC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 7.16663H12.4998M9.58317 18.8333L16.6665 10.0833M6.6665 10.5H9.99984",
    stroke: "#9BA4AC",
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPrivateTempIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/private-temp-icon.97ac7dc2.svg";
export { ForwardRef as ReactComponent };